import React, { useState } from 'react';
import { ArrowLeft, Settings } from 'react-feather';
import { isEmpty } from 'lodash/fp';
import useFetch from 'components/shared/hooks/useFetch';
import trackEvent from 'misc/trackEvent';
import { BetaFeedback } from 'components/BetaProgram';
import Loading from 'components/shared/Loading';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { routes } from 'constants/config';
import EMAILS from 'constants/emails';
import BlankLessonCard from './BlankLessonCard';
import TemplateCard from './TemplateCard';
import LessonCreationModal from '../content/LessonCreationModal';

const Gallery = () => {
  const [lessonModalVisible, setLessonModalVisible] = useState(false);
  const [selectedTemplateInfo, setSelectedTemplateInfo] = useState({});
  const { data = { templates: [] }, loading } = useFetch(
    `${routes.TEMPLATE_GALLERY}?active=true&sort[direction]=asc&sort[column]=title&per_page=100`,
  );

  const { data: workspacesData = {}, loading: workspaceLoading } = useFetch(
    routes.WORKSPACES.INDEX,
  );

  const hasWorkspaces = useFeatureFlags(['workspaces']);
  const isTemplate = !isEmpty(selectedTemplateInfo);

  const closeLessonModal = () => {
    setLessonModalVisible(false);
    setSelectedTemplateInfo({});
    trackEvent('lesson_creation_canceled_from_modal');
  };

  const selectTemplate = templateId => {
    const selectedTemplate = data.templates.find(
      template => template.id === templateId,
    );

    const { id, title, description } = selectedTemplate;

    setSelectedTemplateInfo({ templateId: id, title, description });
    setLessonModalVisible(true);
  };

  return (
    <div className="TemplateGallery">
      <div className="TemplateGallery-header">
        <a
          className="TemplateGallery-backLink link"
          href={routes.CONTENT.INDEX}
        >
          <ArrowLeft size={12} className="mr-8" />
          {t('content.title')}
        </a>
        <h1 className="mt-16">{t('templates.gallery.header')}</h1>
        <div className="mt-8">
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
            {t('templates.gallery.description')}
          </Text>
          <div className="TemplateGallery-links">
            <BetaFeedback
              betaFeatureName="Lesson Templates"
              recipient={EMAILS.TEMPLATE_FEEDBACK}
            />
            <a
              className="c-link ml-20 d-f ai-c"
              href={routes.CONTENT.LIBRARY_TEMPLATES}
            >
              <Settings size="20" className="pr-4" />
              <Text variant={TEXT_VARIANTS.BODY_LINK}>
                {t('templates.gallery.manage')}
              </Text>
            </a>
          </div>
        </div>
      </div>
      {loading && <Loading loading />}
      {!loading && (
        <div className="Card p-16">
          <BlankLessonCard onClick={() => setLessonModalVisible(true)} />
          {data.templates.map(template => (
            <TemplateCard
              key={template.id}
              template={template}
              selectTemplate={selectTemplate}
            />
          ))}
        </div>
      )}
      {lessonModalVisible && !workspaceLoading && (
        <LessonCreationModal
          features={{ workspaces: hasWorkspaces }}
          workspaces={workspacesData.workspaces}
          closeModal={closeLessonModal}
          isTemplate={isTemplate}
          {...selectedTemplateInfo}
        />
      )}
    </div>
  );
};

export default Gallery;
